import {
  ENDPOINT_SETTINGS,
  ENDPOINT_UPDATE_EXECUTE_KEY,
} from 'constants/constants';
import { getAPI, putAPI } from 'utils/commonService';
import { LoginFunction } from 'components/providers/loginContext';

export type SettingsInfo = {
  executeKey: string;
};

export type SettingsBody = {
  executeKey: string;
  wfId: number;
  serviceClass: string;
};

export async function getSettings(
  wfId: number,
  serviceClass: string,
  loginContext: LoginFunction,
  appKey?: string
): Promise<SettingsInfo> {
  const params = { wfId, serviceClass, appKey };
  return (await getAPI(
    ENDPOINT_SETTINGS,
    loginContext,
    params
  )) as SettingsInfo;
}

export type UpdateExecuteKeyBody = {
  executeKeyOld: string;
  executeKeyNew: string;
};

export async function updateExecuteKey(
  executeKeyOld: string,
  executeKeyNew: string,
  loginContext: LoginFunction
) {
  const body: UpdateExecuteKeyBody = { executeKeyOld, executeKeyNew };
  return await putAPI(ENDPOINT_UPDATE_EXECUTE_KEY, loginContext, body);
}
